export enum PaymentFlexStatus {
  Success = 'SUCCESS',
}
